import { getGetCurrentUserQueryKey, useSetTermsAndConditionsConsent } from "@bvhi/backend-api/apis";
import { Box, Button, Link, Stack, Typography } from "@bvhi/ui-base";
import { useQueryClient } from "@tanstack/react-query";
import { Trans, useTranslation } from "react-i18next";
import { useToast } from "../hooks/use-toast";

export function UpdatedTermsOfServiceConsentDashboardWarningBanner() {
  const { t } = useTranslation(["terms-of-service2026"]);
  const queryClient = useQueryClient();
  const { pushCustomSuccessToast, pushCustomErrorToast } = useToast();

  const { mutate: setConsent, isPending } = useSetTermsAndConditionsConsent({
    mutation: {
      onSuccess: () => {
        pushCustomSuccessToast(t("agb2026.banner.button"));
        void queryClient.invalidateQueries({ queryKey: getGetCurrentUserQueryKey() });
      },
      onError: () => {
        pushCustomErrorToast("Fehler beim Speichern der Zustimmung.");
      },
    },
  });

  const handleAgree = () => {
    setConsent({
      data: { termsAndConditionsConsent: new Date().toISOString() },
    });
  };

  return (
    <Box
      sx={{
        mb: 2,
        bgcolor: "grey.50",
        p: 2,
      }}
    >
      <Stack spacing={1}>
        <Typography color="error" fontSize="1.1rem" fontWeight={700}>
          {t("agb2026.banner.title")}
        </Typography>
        <Typography color="error" fontWeight={700}>
          {t("agb2026.banner.line2")}
        </Typography>
        <Typography>
          <Trans
            components={{ 0: <Typography color="error.main" component="span" fontWeight={600} /> }}
            i18nKey="agb2026.banner.body"
            ns="terms-of-service2026"
          />
        </Typography>
        <Typography sx={{ mt: 0.5 }}>
          {t("agb2026.banner.link.prefix")}
          <Link
            href="/terms-of-service"
            rel="noopener noreferrer"
            sx={{ color: "primary.main", fontWeight: 600, textDecoration: "underline" }}
            target="_blank"
          >
            {t("agb2026.banner.link.word")}
          </Link>
          {t("agb2026.banner.link.suffix")}
        </Typography>
        <Box sx={{ mt: 1.5 }}>
          <Button color="primary" disabled={isPending} onClick={handleAgree} size="small" variant="contained">
            {t("agb2026.banner.button")}
          </Button>
        </Box>
      </Stack>
    </Box>
  );
}
